import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AmlHistoryRequest, ExploreConnectionRequest } from '@/api';
import {
  InvestigationHistoryData,
  InvestigationHistoryItemData,
} from '../models';

export interface InvestigationHistorySliceState {
  data: InvestigationHistoryData;
  loading: boolean;
  error: string | null;
}

const initialState: InvestigationHistorySliceState = {
  data: null,
  loading: false,
  error: null,
};

const investigationHistorySlice = createSlice({
  name: 'investigationHistory',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<InvestigationHistoryData>) => ({
      ...state,
      data: action.payload,
    }),
    updateItem: (
      state,
      action: PayloadAction<InvestigationHistoryItemData>,
    ) => {
      if (state.data?.items) {
        const currentItems: InvestigationHistoryItemData[] = JSON.parse(
          JSON.stringify(state.data?.items || []),
        );
        const newItems = [...currentItems];

        if (action.payload) {
          const itemIndex = currentItems.findIndex(
            (item) => item.uuid === action.payload.uuid,
          );

          if (itemIndex !== -1) {
            newItems.splice(itemIndex, 1, action.payload);
          }
        }

        state.data.items = newItems;
      }
    },
    addData: (state, action: PayloadAction<InvestigationHistoryData>) => {
      if (action.payload === null) {
        return {
          ...state,
          data: null,
        };
      }

      const currentItems = JSON.parse(JSON.stringify(state.data?.items || []));
      const { items, ...newData } = action.payload;

      return {
        ...state,
        data: {
          ...state.data,
          ...newData,
          items: [...currentItems, ...items],
        },
      };
    },
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    fetchInvestigationHistory: (
      state,
      action: PayloadAction<AmlHistoryRequest>,
    ) => ({
      ...state,
      error: null,
      loading: true,
    }),
    checkAgain: (state, action: PayloadAction<string>) => state,
    exploreConnection: (
      state,
      action: PayloadAction<ExploreConnectionRequest>,
    ) => ({
      ...state,
      error: null,
      loading: true,
    }),
  },
});

export { investigationHistorySlice };
